import { render, staticRenderFns } from "./PurchaseOrderAttachment.vue?vue&type=template&id=1300c69a&scoped=true"
import script from "./PurchaseOrderAttachment.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300c69a",
  null
  
)

export default component.exports